<template>
  <div id="app">
    <router-view/>
    <!-- <SingleCallUseEmedia ref = "call" @swtichVideoOral="swtichVideoOral"></SingleCallUseEmedia> -->
  </div>
</template>

<script>
  import {mapActions,mapGetters,mapState} from 'vuex';
  import SingleCallUseEmedia from "@/components/MessageManage/Components/SingleCallUseEmedia/index";
  import {getPhone} from '@/api/request/commonService';
  export default {
    name: 'App',
    methods:{
      ...mapActions(["onSendText"]),
      // 表示关闭视频面试
    swtichVideoOral(state,word,name) {
      const options = {
        chatType:'contact',
        // 表示发送给谁
        chatId: name,
        // 表示发送消息
        message: state ? `对方发起了${word}通话`:`${word}通话已结束`,
        langType:'12'
      }
      this.onSendText(options)
     },

     // 判断是否完善信息
      getIsPerfect() {
        getPhone().then(res => {
          if (res.code =='200') {
              if (res.data.isPerfect !='1') {
                 this.$store.dispatch("_perfectCheck", this.$CommonUtil._getuuId());
                 return false;
              }
            } else {
             // 设置vuex的登录验证
              this.$store.dispatch("_loginCheck", this.$CommonUtil._getuuId());
              return false;
            }
        })
      },
    },
    watch:{
      /**
     * desc 监听多端同步
     */
    noticeCallMsg(msg) {
      this.$refs.call.receivedMsg(msg)
     },
     browseCount:{
      handler(val) {
        if (val && val >= 6) {
          this.getIsPerfect()
          this.$store.commit("clearBrowseCount")
        }
      },
      deep: true
     }
    },
    computed:{
      ...mapGetters({
        noticeCallMsg:'onNoticeCallMsg'
      }),
       ...mapState({
        // 获取浏览次数
        browseCount: state => state.browseCount,
      })
    },
    components: {
      SingleCallUseEmedia
    },
    created() {
      /* 页面刷新事件 */
      const pageReflshHandler = () => {
          /* 表示环信刷新中 */
          sessionStorage.setItem('hx_loading', '1');
      };
      window.addEventListener("beforeunload", pageReflshHandler);
      this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("beforeunload", pageReflshHandler);
      });
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue